export const CountryData = [
  {
    name: "SOUTH AFRICA",
    code: "ZAF",
  },
  {
    name: "ANDORRA",
    code: "AND",
  },
  {
    name: "UNITED ARAB EMIRATES",
    code: "ARE",
  },
  {
    name: "AFGHANISTAN",
    code: "AFG",
  },
  {
    name: "ANTIGUA AND BARBUDA",
    code: "ATG",
  },
  {
    name: "ANGUILLA",
    code: "AIA",
  },
  {
    name: "ALBANIA",
    code: "ALB",
  },
  {
    name: "ARMENIA",
    code: "ARM",
  },
  {
    name: "NETHERLANDS ANTILLES",
    code: "ANT",
  },
  {
    name: "ANGOLA",
    code: "AGO",
  },
  {
    name: "ANTARCTICA",
    code: "ATA",
  },
  {
    name: "ARGENTINA",
    code: "ARG",
  },
  {
    name: "AMERICAN SAMOA",
    code: "ASM",
  },
  {
    name: "AUSTRIA",
    code: "AUT",
  },
  {
    name: "AUSTRALIA",
    code: "AUS",
  },
  {
    name: "ARUBA",
    code: "ABW",
  },
  {
    name: "ALAND ISLAND",
    code: "ALA",
  },
  {
    name: "AZERBAIJAN",
    code: "AZE",
  },
  {
    name: "BOSNIA AND HERZEGOVINA",
    code: "BIH",
  },
  {
    name: "BARBADOS",
    code: "BRB",
  },
  {
    name: "BANGLADESH",
    code: "BGD",
  },
  {
    name: "BELGIUM",
    code: "BEL",
  },
  {
    name: "BURNKINA FASO",
    code: "BFA",
  },
  {
    name: "BULGARIA",
    code: "BGR",
  },
  {
    name: "BAHRAIN",
    code: "BHR",
  },
  {
    name: "BURUNDI",
    code: "BDI",
  },
  {
    name: "BENIN",
    code: "BEN",
  },
  {
    name: "BERMUDA",
    code: "BMU",
  },
  {
    name: "BRUNEI DARUSSALAM",
    code: "BRN",
  },
  {
    name: "BOLIVIA",
    code: "BOL",
  },
  {
    name: "BRAZIL",
    code: "BRA",
  },
  {
    name: "BAHAMAS",
    code: "BHS",
  },
  {
    name: "BHUTAN",
    code: "BTN",
  },
  {
    name: "BOUVET ISLAND",
    code: "BVT",
  },
  {
    name: "BOTSWANA",
    code: "BWA",
  },
  {
    name: "BELARUS",
    code: "BLR",
  },
  {
    name: "BELIZE",
    code: "BLZ",
  },
  {
    name: "CANADA",
    code: "CAN",
  },
  {
    name: "COCOS (KEELING) ISLANDS",
    code: "CCK",
  },
  {
    name: "CONGO, THE DEMOCRATIC REPUBLIC OF THE CONGO",
    code: "COD",
  },
  {
    name: "CENTRAL AFRICAN REPUBLIC",
    code: "CAF",
  },
  {
    name: "CONGO",
    code: "COG",
  },
  {
    name: "SWITZERLAND",
    code: "CHE",
  },
  {
    name: "COTE D_IVOIRE",
    code: "CIV",
  },
  {
    name: "COOK ISLANDS",
    code: "COK",
  },
  {
    name: "CHILE",
    code: "CHL",
  },
  {
    name: "CAMEROON",
    code: "CMR",
  },
  {
    name: "CHINA",
    code: "CHN",
  },
  {
    name: "COLUMBIA",
    code: "COL",
  },
  {
    name: "COSTA RICA",
    code: "CRI",
  },
  {
    name: "CUBA",
    code: "CUB",
  },
  {
    name: "CAPE VERDE",
    code: "CPV",
  },
  {
    name: "CHRISTMAS ISLAND",
    code: "CXR",
  },
  {
    name: "CYPRUS",
    code: "CYP",
  },
  {
    name: "CZECH REPUBLIC",
    code: "CZE",
  },
  {
    name: "GERMANY",
    code: "DEU",
  },
  {
    name: "DJIBOUTI",
    code: "DJI",
  },
  {
    name: "DENMARK",
    code: "DNK",
  },
  {
    name: "DOMINICA",
    code: "DMA",
  },
  {
    name: "DOMINICAN REPUBLIC",
    code: "DOM",
  },
  {
    name: "ALGERIA",
    code: "DZA",
  },
  {
    name: "ECUADOR",
    code: "ECU",
  },
  {
    name: "ESTONIA",
    code: "EST",
  },
  {
    name: "EGYPT",
    code: "EGY",
  },
  {
    name: "WESTERN SAHARA",
    code: "ESH",
  },
  {
    name: "ERITREA",
    code: "ERI",
  },
  {
    name: "SPAIN",
    code: "ESP",
  },
  {
    name: "ETHIOPIA",
    code: "ETH",
  },
  {
    name: "FINLAND",
    code: "FIN",
  },
  {
    name: "FIJI",
    code: "FJI",
  },
  {
    name: "FALKLANDS ISLANDS (MALVINAS)",
    code: "FLK",
  },
  {
    name: "MICRONESIA (FEDERATED STATES OF)",
    code: "FSM",
  },
  {
    name: "FAEROE ISLANDS",
    code: "FRO",
  },
  {
    name: "FRANCE",
    code: "FRA",
  },
  {
    name: "GABON",
    code: "GAB",
  },
  {
    name: "UNITED KINGDOM",
    code: "GBR",
  },
  {
    name: "GRENADA",
    code: "GRD",
  },
  {
    name: "GEORGIA",
    code: "GEO",
  },
  {
    name: "FRENCH GUIANA",
    code: "GUF",
  },
  {
    name: "GUERNSEY",
    code: "GUE",
  },
  {
    name: "GHANA",
    code: "GHA",
  },
  {
    name: "GIBRALTAR",
    code: "GIB",
  },
  {
    name: "GREENLAND",
    code: "GRL",
  },
  {
    name: "GAMBIA",
    code: "GMB",
  },
  {
    name: "GUINEA",
    code: "GIN",
  },
  {
    name: "GUADELOUPE",
    code: "GLP",
  },
  {
    name: "EQUATORIAL GUINEA",
    code: "GNQ",
  },
  {
    name: "GREECE",
    code: "GRC",
  },
  {
    name: "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS",
    code: "SGS",
  },
  {
    name: "GUATEMALA",
    code: "GTM",
  },
  {
    name: "GUAM",
    code: "GUM",
  },
  {
    name: "GUINEA-BISSAU",
    code: "GNB",
  },
  {
    name: "GUYANA",
    code: "GUY",
  },
  {
    name: "HONG KONG",
    code: "HKG",
  },
  {
    name: "HEARD ISLAND AND MC DONALD ISLANDS",
    code: "HMD",
  },
  {
    name: "HONDURAS",
    code: "HND",
  },
  {
    name: "CROATIA",
    code: "HRV",
  },
  {
    name: "HAITI",
    code: "HTI",
  },
  {
    name: "HUNGARY",
    code: "HUN",
  },
  {
    name: "INDONESIA",
    code: "IDN",
  },
  {
    name: "IRELAND, REPUBLIC OF",
    code: "IRL",
  },
  {
    name: "ISRAEL",
    code: "ISR",
  },
  {
    name: "ISLE OF MAN",
    code: "IMA",
  },
  {
    name: "INDIA",
    code: "IND",
  },
  {
    name: "BRITISH INDIAN OCEAN TERRITORY",
    code: "IOT",
  },
  {
    name: "IRAQ",
    code: "IRQ",
  },
  {
    name: "IRAN (ISLAMIC REPUBLIC OF)",
    code: "IRN",
  },
  {
    name: "ICELAND",
    code: "ISL",
  },
  {
    name: "ITALY",
    code: "ITA",
  },
  {
    name: "JERSEY",
    code: "JER",
  },
  {
    name: "JAMAICA",
    code: "JAM",
  },
  {
    name: "JORDAN",
    code: "JOR",
  },
  {
    name: "JAPAN",
    code: "JPN",
  },
  {
    name: "KENYA",
    code: "KEN",
  },
  {
    name: "KYRGYZSTAN",
    code: "KGZ",
  },
  {
    name: "CAMBODIA",
    code: "KHM",
  },
  {
    name: "KIRIBATI",
    code: "KIR",
  },
  {
    name: "COMOROS",
    code: "COM",
  },
  {
    name: "SAINT KITTS & NEVIS",
    code: "KNA",
  },
  {
    name: "KOREA DEMOCRATIC PEOPLE_S REPUBLIC OF",
    code: "PRK",
  },
  {
    name: "KOREA, REPUBLIC OF",
    code: "KOR",
  },
  {
    name: "KUWAIT",
    code: "KWT",
  },
  {
    name: "CAYMAN ISLANDS",
    code: "CYM",
  },
  {
    name: "KAZAKSTAN",
    code: "KAZ",
  },
  {
    name: "LAO PEOPLE_S DEMOCRATIC REPUBLIC",
    code: "LAO",
  },
  {
    name: "LEBANON",
    code: "LBN",
  },
  {
    name: "SAINT LUCIA",
    code: "LCA",
  },
  {
    name: "LIECHTENSTEIN",
    code: "LIE",
  },
  {
    name: "SRI LANKA",
    code: "LKA",
  },
  {
    name: "LIBERIA",
    code: "LBR",
  },
  {
    name: "LESOTHO",
    code: "LSO",
  },
  {
    name: "LITHUANIA",
    code: "LTU",
  },
  {
    name: "LUXEMBOURG",
    code: "LUX",
  },
  {
    name: "LATVIA",
    code: "LVA",
  },
  {
    name: "LIBYAN ARAB JAMAHIRIYA",
    code: "LBY",
  },
  {
    name: "MOROCCO",
    code: "MAR",
  },
  {
    name: "MONACO",
    code: "MCO",
  },
  {
    name: "MOLDOVA, REPUBLIC OF",
    code: "MDA",
  },
  {
    name: "MONTENEGRO, REPULIC OF",
    code: "MON",
  },
  {
    name: "MADAGASCAR",
    code: "MDG",
  },
  {
    name: "MARSHALL ISLANDS",
    code: "MHL",
  },
  {
    name: "MACEDONIA,THE FORMER YUGOSLAV REPUBLIC OF",
    code: "MKD",
  },
  {
    name: "MALI",
    code: "MLI",
  },
  {
    name: "MYANMAR",
    code: "MMR",
  },
  {
    name: "MONGOLIA",
    code: "MNG",
  },
  {
    name: "MACAU",
    code: "MAC",
  },
  {
    name: "NORTHERN MARIANA ISLANDS",
    code: "MNP",
  },
  {
    name: "MARTINIQUE",
    code: "MTQ",
  },
  {
    name: "MAURITANIA",
    code: "MRT",
  },
  {
    name: "MONTSERRAT",
    code: "MSR",
  },
  {
    name: "MALTA",
    code: "MLT",
  },
  {
    name: "MAURITIUS",
    code: "MUS",
  },
  {
    name: "MALDIVES",
    code: "MDV",
  },
  {
    name: "MALAWI",
    code: "MWI",
  },
  {
    name: "MEXICO",
    code: "MEX",
  },
  {
    name: "MALAYSIA",
    code: "MYS",
  },
  {
    name: "MOZAMBIQUE",
    code: "MOZ",
  },
  {
    name: "NAMIBIA",
    code: "NAM",
  },
  {
    name: "NEW CALEDONIA",
    code: "NCL",
  },
  {
    name: "NIGER",
    code: "NER",
  },
  {
    name: "NORFOLK ISLAND",
    code: "NFK",
  },
  {
    name: "NIGERIA",
    code: "NGA",
  },
  {
    name: "NICARAGUA",
    code: "NIC",
  },
  {
    name: "NETHERLANDS",
    code: "NLD",
  },
  {
    name: "NORWAY",
    code: "NOR",
  },
  {
    name: "NEPAL",
    code: "NPL",
  },
  {
    name: "NAURU",
    code: "NRU",
  },
  {
    name: "NIUE",
    code: "NIU",
  },
  {
    name: "NEW ZEALAND",
    code: "NZL",
  },
  {
    name: "OMAN",
    code: "OMN",
  },
  {
    name: "PANAMA",
    code: "PAN",
  },
  {
    name: "PERU",
    code: "PER",
  },
  {
    name: "FRENCH POLYNESIA",
    code: "PYF",
  },
  {
    name: "PAPUA NEW GUINEA",
    code: "PNG",
  },
  {
    name: "PHILIPPINES",
    code: "PHL",
  },
  {
    name: "PAKISTAN",
    code: "PAK",
  },
  {
    name: "POLAND",
    code: "POL",
  },
  {
    name: "SAINT PIERRE & MIQUELON",
    code: "SPM",
  },
  {
    name: "PITCAIRN",
    code: "PCN",
  },
  {
    name: "PUERTO RICO",
    code: "PRI",
  },
  {
    name: "PALESTINIAN TERRITORY, OCCUPIED",
    code: "PSE",
  },
  {
    name: "PORTUGAL",
    code: "PRT",
  },
  {
    name: "PALAU",
    code: "PLW",
  },
  {
    name: "PARAGUAY",
    code: "PRY",
  },
  {
    name: "QATAR",
    code: "QAT",
  },
  {
    name: "REUNION",
    code: "REU",
  },
  {
    name: "ROMANIA",
    code: "ROM",
  },
  {
    name: "SERBIA, REPUBLIC OF",
    code: "SER",
  },
  {
    name: "RUSSIAN FEDERATION",
    code: "RUS",
  },
  {
    name: "RWANDA",
    code: "RWA",
  },
  {
    name: "SAUDI ARABIA",
    code: "SAU",
  },
  {
    name: "SOLOMON ISLANDS",
    code: "SLB",
  },
  {
    name: "SEYCHELLES",
    code: "SYC",
  },
  {
    name: "SUDAN",
    code: "SDN",
  },
  {
    name: "SWEDEN",
    code: "SWE",
  },
  {
    name: "SINGAPORE",
    code: "SGP",
  },
  {
    name: "SAINT HELENA",
    code: "SHN",
  },
  {
    name: "SLOVENIA",
    code: "SVN",
  },
  {
    name: "SVALBARD & JAN MAYEN",
    code: "SJM",
  },
  {
    name: "SLOVAKIA",
    code: "SVK",
  },
  {
    name: "SIERRA LEONE",
    code: "SLE",
  },
  {
    name: "SAN MARINO",
    code: "SMR",
  },
  {
    name: "SENEGAL",
    code: "SEN",
  },
  {
    name: "SOMALIA",
    code: "SOM",
  },
  {
    name: "SURINAME",
    code: "SUR",
  },
  {
    name: "SAO TOME & PRINCIPE",
    code: "STP",
  },
  {
    name: "EL SALVADOR",
    code: "SLV",
  },
  {
    name: "SYRIAN ARAB REPUBLIC",
    code: "SYR",
  },
  {
    name: "SWAZILAND",
    code: "SWZ",
  },
  {
    name: "TURKS & CAICOS ISLANDS",
    code: "TCA",
  },
  {
    name: "CHAD",
    code: "TCD",
  },
  {
    name: "FRENCH SOUTHERN TERRITORIES",
    code: "ATF",
  },
  {
    name: "TOGO",
    code: "TGO",
  },
  {
    name: "THAILAND",
    code: "THA",
  },
  {
    name: "TAJIKISTAN",
    code: "TJK",
  },
  {
    name: "TOKELAU",
    code: "TKL",
  },
  {
    name: "TURKMENISTAN",
    code: "TKM",
  },
  {
    name: "TUNISIA",
    code: "TUN",
  },
  {
    name: "TONGA",
    code: "TON",
  },
  {
    name: "EAST TIMOR",
    code: "TMP",
  },
  {
    name: "TURKEY",
    code: "TUR",
  },
  {
    name: "TRINIDAD & TOBAGO",
    code: "TTO",
  },
  {
    name: "TUVALU",
    code: "TUV",
  },
  {
    name: "TAIWAN,PROVINCE OF CHINA",
    code: "TWN",
  },
  {
    name: "TANZANIA,UNITED REPUBLIC OF",
    code: "TZA",
  },
  {
    name: "UKRAINE",
    code: "UKR",
  },
  {
    name: "UGANDA",
    code: "UGA",
  },
  {
    name: "UNITED STATES MINOR OUTLYING ISLANDS",
    code: "UMI",
  },
  {
    name: "UNITED STATES",
    code: "USA",
  },
  {
    name: "URUGUAY",
    code: "URY",
  },
  {
    name: "UZBEKISTAN",
    code: "UZB",
  },
  {
    name: "HOLY SEE (VATICAN CITY STATE)",
    code: "VAT",
  },
  {
    name: "SAINT VINCENT & THE GRENADINES",
    code: "VCT",
  },
  {
    name: "VENEZUELA",
    code: "VEN",
  },
  {
    name: "VIRGIN ISLANDS (BRITISH)",
    code: "VGB",
  },
  {
    name: "VIRGIN ISLANDS (U.S)",
    code: "VIR",
  },
  {
    name: "VIET NAM",
    code: "VNM",
  },
  {
    name: "VANUATU",
    code: "VUT",
  },
  {
    name: "WALLIS & FUTUNA ISLANDS",
    code: "WLF",
  },
  {
    name: "SAMOA",
    code: "WSM",
  },
  {
    name: "YEMEN",
    code: "YEM",
  },
  {
    name: "MAYOTTE",
    code: "MYT",
  },
  {
    name: "YUGOSLAVIA",
    code: "YUG",
  },
  {
    name: "ZAMBIA",
    code: "ZMB",
  },
  {
    name: "ZIMBABWE",
    code: "ZWE",
  },
  {
    name: "COUNTRY UNKNOWN",
    code: "ZZZ",
  },
];
